import './Stakeholder.scss'
import React, {useState} from 'react'
import {Link} from "react-router-dom"
import { withRouter } from '../../helpers/withRouter'
import {Button, Col, Dropdown, Icon, Layout, Menu, message, Row, Select, Tooltip} from 'antd'
import {useTranslation} from "react-i18next"
import {PublicPortal, StakePrivate} from '../'
import Footer from './Footer'
import {SessionStorageService} from '../../services'

import ImageResources from "../../layouts/commonComponent/components/ExternalResources/ImageResources";

const { Header } = Layout

const StakeholderPortal = ({ countryCode }) => {
	const { t } = useTranslation();
	const [clientes, setClientes] = useState(null)
	const [user, setUser] = useState(null)
	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [selectedClient, setSelectedClient] = useState(null);
	const [showPrivate, setShowPrivate] = useState(false);
	const [loginRut, setLoginRut] = useState(null);
	const [activeTabPrivate, setActiveTabPrivate] = useState(null);
	const [profileOpenTrigger, setProfileOpenTrigger] = useState(0);

	document.title = t('portal.users.title')
	const { Option } = Select;

	const refreshUser = (updatedUser) => {
		setUser(updatedUser)
	}
	
	const handleLogin = async (record, code) => {
		if (code === 'x') {
			record.activeUser = true
		} else if (code === '200' || code === '202') {
			record.activeUser = (code === '200')
			SessionStorageService.create('portal-user-id', record.id)
			SessionStorageService.create('portal-user-status', code)
			if (code === '202') {
				message.warn({ content: t('messages.aml.recommended.change.pwd')})
			}
		} else {
			record.activeUser = false
		}
		setUser(record)
		setClientes(record.detalleCuenta)
		if (record.detalleCuenta.length === 1) {
			setSelectedClient(record.detalleCuenta[0])
			setShowPrivate(true)
		}
		setIsLoggedIn(true)
	}

	const handleLogout = async (e) => {
		setIsLoggedIn(false)
		setUser(null)
		setShowPrivate(false)
		setActiveTabPrivate(null)
		SessionStorageService.delete('portal-user-id')
		SessionStorageService.delete('portal-user-status')
	}

	const handleOpenProfile = () => {
		if (!selectedClient) {
			message.error(t('portal.company.must.select'))
			return
		}
		setShowPrivate(true)
		setActiveTabPrivate('tab-profile')
		setProfileOpenTrigger(prev => prev + 1)
	}

	const dropdownMenu = (
		<Menu>
			{selectedClient && showPrivate && (
				<Menu.Item>
					<Link to={'#'} onClick={handleOpenProfile}>
						<Icon type="user" /> &nbsp;{t('portal.profile.title')}
					</Link>
				</Menu.Item>
			)}
			<Menu.Item>
				<Link to={'#'} onClick={handleLogout}>
					<Icon type="logout" /> {t('messages.aml.logout')}
				</Link>
			</Menu.Item>
		</Menu>
	)

	const handleSelectEntity = (id) => {
		let cliente = clientes.filter(c => c.clCliente.id === id)[0]
		setSelectedClient(cliente)
	}

	const handlePrivatePortalOnClick = () => {
		if (selectedClient) {
			setShowPrivate(true)
		} else {
			message.error(t('portal.company.must.select'))
		}
	}

	const getUrlPerson = (cliente, clCliente) => {
		if(cliente.outsourcer && clCliente?.subcliente) {
			return ('/getImageClient?clientId=' + cliente.id + '&subclienteId=' + clCliente.subcliente.id)
		}else {
			return ('/getImageClient?clientId=' + cliente.id)
		}
	}

	const handleLoginRut = (rut) => {
		setLoginRut(rut)
	}

	const handlePageBack = () => {
		setShowPrivate(false)
		setSelectedClient(null)
	}

	return (
		<div className="stakeholder">
			<>
				<Header className="header">
					{/* {!isLoggedIn &&
						<div className="register">
							<Button type="link" onClick={null}>Registrarse</Button>
						</div>
					} */}
					<div className="logo">
						{selectedClient && showPrivate &&
							<ImageResources
								url={getUrlPerson(selectedClient.cliente, selectedClient.clCliente)}
								key={Math.random()}
							/>
						}
					</div>
					{isLoggedIn && user !== null &&
						<div className="current-user">
							<Dropdown overlay={dropdownMenu}>
								<Button key={user.nombre}>
									<Icon type="user" /> {user.nombre} <Icon type="caret-down" />
								</Button>
							</Dropdown>
						</div>
					}
				</Header>
				{isLoggedIn ?
					!showPrivate ?
						clientes?.length > 0 ?
							<>
								<div className="stakeholder-public">
									<div className="login">
										<div className="login-content">
											<Row>
												<Col xs={20} offset={2} className="login-container">
													<div className="login-box" style={{width:600}}>
														<Row gutter={[0, 30]}>
															<Col span={24}>
																{t('messages.aml.selectCompany')}
															</Col>
															<Col>
																<Select style={{ width: '100%' }} placeholder={t('messages.aml.selectCompany')} onChange={handleSelectEntity}>
																	{clientes.map(item =>
																		<Option value={item.clCliente.id}>
																			{item.clCliente.rut} - {item.clCliente.nombre} - {item.cliente.name}
																		</Option>
																	)
																	}
																</Select>
															</Col>
															<Col span={24}>
																<Button type='primary' onClick={() => handlePrivatePortalOnClick()}>
																	{t('portal.title.next')}
																</Button>
															</Col>
														</Row>
													</div>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</>
							:
							<div align="center" style={{ padding: 200 }}>
								<h1>{t('portal.company.not.associated')}</h1>
								<br />
								<Button type="primary" onClick={handleLogout}>{t('messages.aml.back')}</Button>
							</div>
						:
						<>
							{clientes && clientes.length > 1 && (
								<div style={{ display: 'flex', justifyContent: 'flex-start' }}>
									<Tooltip title="Regresar a selección de Empresa" placement="right">
										<Icon
											type="arrow-left"
											style={{ fontSize: 30, marginLeft: 0, marginTop: 10 }}
											onClick={() => handlePageBack()}
										/>
									</Tooltip>
								</div>
							)}
							<StakePrivate
								user={user}
								client={selectedClient.cliente}
								currentUser={selectedClient.clCliente}
								externalActiveTab={activeTabPrivate}
								profileOpenTrigger={profileOpenTrigger}
								refreshUser={refreshUser}
							/>
						</>
					:
					<PublicPortal countryCode={countryCode} successHandler={handleLogin} handleLoginRut={handleLoginRut} />
				}
				<Footer country={countryCode} client={selectedClient?.cliente}/>
			</>
		</div>
	)
}

export default withRouter(StakeholderPortal)
